if (!customElements.get("cart-gift")) {
  class CartGift extends HTMLElement {
    constructor() {
      super();

      
      this.cartNotification = document.querySelector("cart-notification");
      this.giftInput = this.querySelector("#cart-gift");
      this.addEventListener("change", this.handleGiftInput.bind(this));
      this.giftProductId = this.dataset.giftProduct
    }

    handleGiftInput() {
      const payload = {};
  
      this.setGiftWrapAttribute(payload);
      this.setGiftWrapProduct(payload);
      this.setCartNotificationSections(payload);
    
      return fetch(routes.cart_update_url, {
        ...fetchConfig(),
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.log(response)
            this.handleErrorMessage(response.description);
            return;
          }
          
          this.renderContents(response, this.cartNotification);
          this.recommendedProducts = document.querySelector("[data-cart-recommended-products]");
      
          if(this.recommendedProducts) {
            const renderCart = new Event('render-cart'); 
            this.recommendedProducts.dispatchEvent(renderCart);
          }
          const isCartPage = document
            .querySelector("body")
            .classList.contains("template-cart");
          if (isCartPage) {
            location.reload();
          }
        });
    }

    renderContents(parsedState, element) {
    
      element.productId = parsedState.id;
      element.getSectionsToRender().forEach((section) => {
        try {
          document.getElementById(section.id).innerHTML =
            element.getSectionInnerHTML(
              parsedState.sections[section.id],
              section.selector
            );
        } catch (e) {
          if (section.id != "cart-count") {
            throw e;
          }
        }
      });
    }

    handleErrorMessage(errorMessage = false) {
      console.error("Error updating product item", errorMessage);
    }

    setGiftWrapAttribute(payload) {
      payload.attributes = payload.attributes || {};
      payload.attributes["Gift wrap"] = this.giftInput.checked ? "Yes" : "";
    }
    setGiftWrapProduct(payload) {
      payload.updates = payload.updates || {};
      payload.updates[this.giftProductId] = this.giftInput.checked ? 1 : 0;
    }
    setCartNotificationSections(payload) {
    
      payload.sections = this.cartNotification
        .getSectionsToRender()
        .map((section) => section.id);
      payload.sections_url = window.location.pathname;
    }
  }

  customElements.define("cart-gift", CartGift);
}
